import { render, staticRenderFns } from "./DesignTokenPreview.vue?vue&type=template&id=1489693a&"
import script from "./DesignTokenPreview.vue?vue&type=script&lang=js&"
export * from "./DesignTokenPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports